<div class="filter-for-list">
    <app-user-crud [userId]="null" [mode]="CRUD_MODE.create"></app-user-crud>
    <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
        <input matInput (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
    </mat-form-field>

    <mat-slide-toggle class="sliderActiveList" (change)="reLoadList()" ngModel="activeUser" placement="right"
                      [ngbTooltip]="'USER_ACTIVE_SLIDER_TOOLTIP' | translate">{{getActiveTextForSlider()}}
    </mat-slide-toggle>


    <div class="deviceTypeFilter" placement="right">

        <mat-chip-list>
            <mat-chip *ngFor="let userRole of userRoles index as i "
                      [ngClass]="{'selected' : userRole.value === roleSelected}"
                      (click)="filterListByUserRole(userRole.value)"
                      ngbTooltip="Click to filter on this role">
                {{userRole.value|translate}}
            </mat-chip>
        </mat-chip-list>

    </div>


    <br clear="both"/>
</div>
<app-progressbar *ngIf="showSpinner===true"></app-progressbar>
<table mat-table [dataSource]="matTableDataSource" matSort class="table-striped" style="width:100%">

    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
        <td mat-cell *matCellDef="let user"> {{user.id}}</td>
    </ng-container>

    <ng-container matColumnDef="level">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LEVEL'|translate}}</th>
        <td mat-cell *matCellDef="let user">
            <mat-chip-list>
                <mat-chip class="selected" matBadgePosition="below before" matBadgeColor="accent"
                          [matBadge]="user.level.level">
                    {{user.level.name}}
                </mat-chip>
            </mat-chip-list>


        </td>
    </ng-container>

    <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'EMAIL'|translate}}</th>
        <td mat-cell *matCellDef="let user"> {{user.email}}</td>
    </ng-container>

    <ng-container matColumnDef="roles">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ROLES'|translate}}</th>
        <td mat-cell *matCellDef="let user">

            <div class="deviceTypeFilter" placement="right"
                 ngbTooltip="Click to filter on this role">
                <mat-chip-list>
                    <mat-chip *ngFor="let userRole of user.roles index as i "
                              [ngClass]="{'selected' : userRole === roleSelected}"
                              (click)="filterListByUserRole(userRole)">
                        {{userRole|translate}}
                    </mat-chip>
                </mat-chip-list>
            </div>

        </td>
    </ng-container>

    <ng-container matColumnDef="lastname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LASTNAME'|translate}}</th>
        <td mat-cell *matCellDef="let user"> {{user.lastname}}</td>
    </ng-container>

    <ng-container matColumnDef="firstname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'FIRSTNAME'|translate}}</th>
        <td mat-cell *matCellDef="let user"> {{user.firstname}}</td>
    </ng-container>

    <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PHONE'|translate}}</th>
        <td mat-cell *matCellDef="let user"> {{user.phone}}</td>
    </ng-container>

    <ng-container matColumnDef="last_login">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LAST_LOGIN'|translate}}</th>
        <td mat-cell
            *matCellDef="let user"> {{user?.last_login ? (user.last_login | date:'shortDate': 'UTC') : '-' }}</td>
    </ng-container>


    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef width="195px">{{'ACTIONS'|translate}}</th>
        <td mat-cell *matCellDef="let user">
            <div class="d-flex">
                <app-user-crud [userId]="user.id" [mode]="CRUD_MODE.read"></app-user-crud>

                <app-user-crud [userId]="user.id" [mode]="CRUD_MODE.update"></app-user-crud>

                <button type="button" class="btn list-tools" style="background: blue" placement="left"
                        [ngbTooltip]="('RESET_PASSWORD_ICON_TOOLTIP' | translate) + user.email"
                        (click)="sendPasswordEmailToUser(user.email)">
                    <fa-icon [icon]="iconService.faKey"></fa-icon>
                </button>
            </div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="pageSize"></mat-paginator>

